import React from 'react'
import PointTarget from 'react-point'

export default (props) => (
  <PointTarget onPoint={props.onPress}>
    <svg xmlns="http://www.w3.org/2000/svg" 
        className={'icon ' + (props.highlighted ? 'fill-white' : 'fill-grey')} 
        viewBox="0 0 1024 1024" 
        version="1.1"
    >
        <path d="M103.817525 103.55014c0-95.810065 65.879405-131.687801 146.386843-79.690825l609.566461 393.589947c80.542943 51.979224 80.542943 137.066798 0 189.046022l-609.566461 393.660957c-80.507438 51.979224-146.386843 16.101488-146.386843-79.708577L103.817525 103.55014z"/>
    </svg>
  </PointTarget>
)